import { EErrorActionTypes } from '../../actions/error';
import { TErrorState } from '../../types/error';

import { TReduxActions } from '../../types/redux';

const defaultState: TErrorState = null;

export function errorReducer(state: TErrorState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EErrorActionTypes.Clear:
      return null;
    case EErrorActionTypes.Set:
      return action.payload;

    default:
      return state;
  }
}
